import React from 'react';
import { PARTNERS } from '../data/mockData';
import { motion } from 'framer-motion';

const PartnersSection = () => {
  const triplePartners = [...PARTNERS, ...PARTNERS, ...PARTNERS];

  return (
    <section className="bg-[#FDFEFA] py-10 md:py-14 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 mb-6">
        <motion.h3
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-[#242326] text-2xl md:text-3xl font-light font-['Inter']"
        >
          Our Trusted Partners
        </motion.h3>
      </div>

      {/* Scrolling Partner Marquee */}
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#FDFEFA] to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#FDFEFA] to-transparent z-10" />

        <div className="flex animate-scroll-partners">
          {triplePartners.map((partner, i) => (
            <div
              key={`${partner}-${i}`}
              className="flex-shrink-0 px-8 md:px-12 flex items-center"
            >
              <div className="bg-white rounded-lg px-6 py-3 border border-[#242326]/5 hover:border-[#83BF42]/20 transition-colors duration-300">
                <span className="text-[#4A4A48]/70 text-sm md:text-base font-medium font-['Inter'] whitespace-nowrap">
                  {partner}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
